const TWITTER_URL_RE = /https?:\/\/(?:www\.)?(?:twitter\.com|x\.com)\/[^\s"'<>]+/i
const TWEET_ID_RE = /status\/(\d+)/i

export function parseLiveblogPayload(payload) {
    if (payload == null || payload === '') return null

    let value = payload
    if (typeof value === 'string') {
        try {
            value = JSON.parse(value)
        } catch (error) {
            return null
        }
    }

    if (typeof value === 'string') {
        try {
            value = JSON.parse(value)
        } catch (error) {
            return null
        }
    }

    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return null
    }

    return value
}

export function extractTwitterUrlFromText(text) {
    if (!text) return ''
    const plain = String(text).replace(/<[^>]+>/g, ' ')
    const match = plain.match(TWITTER_URL_RE)
    return match ? match[0].replace(/[.,;:!?)]+$/, '') : ''
}

export function resolveTwitterUrl(item) {
    if (!item || String(item.content_type || '').toLowerCase() !== 'twitter') {
        return ''
    }

    const payload = parseLiveblogPayload(item.payload)
    if (payload) {
        const direct = payload.url || payload.tweet_url || payload.link
        if (direct) return String(direct).trim()

        if (payload.tweet_id) {
            const author = String(payload.author || '')
                .replace(/^@/, '')
                .trim()
            if (author) {
                return `https://twitter.com/${author}/status/${payload.tweet_id}`
            }
            return `https://x.com/i/web/status/${payload.tweet_id}`
        }
    }

    return (
        extractTwitterUrlFromText(item.title) ||
        extractTwitterUrlFromText(item.body) ||
        extractTwitterUrlFromText(item.comment) ||
        ''
    )
}

export function resolveTweetId(item, twitterUrl = '') {
    const payload = parseLiveblogPayload(item && item.payload)
    if (payload && payload.tweet_id) {
        return String(payload.tweet_id).trim()
    }

    const url = twitterUrl || resolveTwitterUrl(item)
    if (!url) return ''

    const match = String(url).match(TWEET_ID_RE)
    return match ? match[1] : ''
}

export function resolveTwitterAuthor(item) {
    const payload = parseLiveblogPayload(item && item.payload)
    const author = payload && payload.author
    if (!author) return ''
    return author.startsWith('@') ? author : `@${author}`
}

const VIDEO_URL_RE = /https?:\/\/[^\s"'<>]+/i
const DIRECT_VIDEO_RE = /\.(mp4|webm|ogg|m3u8)(\?.*)?$/i

function extractUrlFromText(text) {
    if (!text) return ''
    const plain = String(text).replace(/<[^>]+>/g, ' ')
    const match = plain.match(VIDEO_URL_RE)
    return match ? match[0].replace(/[.,;:!?)]+$/, '') : ''
}

function extractYoutubeId(value) {
    if (!value) return ''
    const input = String(value).trim()
    if (!input) return ''
    if (/^[\w-]{11}$/.test(input)) return input

    const patterns = [
        /(?:youtube\.com\/watch\?v=|youtube\.com\/shorts\/|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/i,
        /[?&]v=([\w-]{11})/i,
    ]
    for (const pattern of patterns) {
        const match = input.match(pattern)
        if (match && match[1]) return match[1]
    }
    return ''
}

function extractVimeoId(value) {
    if (!value) return ''
    const input = String(value).trim()
    if (!input) return ''
    if (/^\d+$/.test(input)) return input

    const match = input.match(/vimeo\.com\/(?:video\/)?(\d+)/i)
    return match ? match[1] : ''
}

function isVideoLikeType(contentType) {
    const type = String(contentType || '').toLowerCase()
    return type === 'video' || type === 'highlight'
}

export function resolveVideoPlayback(item) {
    if (!item || !isVideoLikeType(item.content_type)) {
        return null
    }

    const payload = parseLiveblogPayload(item.payload) || {}
    const provider = String(payload.provider || '').toLowerCase().trim()
    const embedId = payload.embed_id != null && payload.embed_id !== '' ? String(payload.embed_id).trim() : ''
    const url =
        (payload.url && String(payload.url).trim()) ||
        extractUrlFromText(item.title) ||
        extractUrlFromText(item.body) ||
        ''

    const youtubeId =
        (provider === 'youtube' && embedId) ||
        extractYoutubeId(embedId) ||
        extractYoutubeId(url)
    if (provider === 'youtube' || youtubeId) {
        const id = youtubeId || embedId
        if (id) {
            const link = url || `https://www.youtube.com/watch?v=${id}`
            return {
                kind: 'iframe',
                src: `https://www.youtube.com/embed/${id}`,
                link,
                provider: 'YouTube',
            }
        }
    }

    const vimeoId =
        (provider === 'vimeo' && embedId) ||
        extractVimeoId(embedId) ||
        extractVimeoId(url)
    if (provider === 'vimeo' || vimeoId) {
        const id = vimeoId || embedId
        if (id) {
            const link = url || `https://vimeo.com/${id}`
            return {
                kind: 'iframe',
                src: `https://player.vimeo.com/video/${id}`,
                link,
                provider: 'Vimeo',
            }
        }
    }

    if (embedId && !url) {
        return {
            kind: 'iframe',
            src: `https://www.youtube.com/embed/${embedId}`,
            link: `https://www.youtube.com/watch?v=${embedId}`,
            provider: provider || 'Video',
        }
    }

    if (url && DIRECT_VIDEO_RE.test(url)) {
        return {
            kind: 'video',
            src: url,
            link: url,
            provider: provider || 'Video',
        }
    }

    if (url) {
        return {
            kind: 'link',
            src: '',
            link: url,
            provider: provider || 'Video',
        }
    }

    return null
}

export function resolveVideoProviderLabel(item) {
    const playback = resolveVideoPlayback(item)
    if (playback && playback.provider) return playback.provider

    const payload = parseLiveblogPayload(item && item.payload)
    if (payload && payload.provider) return String(payload.provider)
    return ''
}
